import {doSignUp, SignUpData, SignUpPayload} from "../auth/auth.client";
import {metricsQueue} from "../../utils/metricsCollector";
import {RegistrationError} from "../auth/errors";
import {INPUT_FIELD_MAX_CHARACTER_LIMITS} from "../../utils/globalInputConstants";
import {SignUpUserData} from "../ps-models";


export interface CampaignSignUpData extends SignUpData {
    userProvidedCompanyName: string;
    campaign: string;
}

export class CampaignSignUpPayload extends SignUpPayload {
    readonly userProvidedCompanyName: string;
    readonly campaign: string;
    constructor(signUpPayload: CampaignSignUpData) {
        super(signUpPayload);
        const {userProvidedCompanyName, campaign} = signUpPayload;
        this.userProvidedCompanyName = userProvidedCompanyName.trim()
        this.campaign = campaign.trim();

        if(!this.campaign) {
            throw new RegistrationError("Campaign is no longer active.", "custom/failed-signup-inputs")
        }

        if (!this.userProvidedCompanyName) {
            throw new RegistrationError("Company name is a required field.", "custom/failed-signup-inputs")
        }

        if(this.userProvidedCompanyName.length > INPUT_FIELD_MAX_CHARACTER_LIMITS.companyName
        ) {
            throw new RegistrationError(`Company name should not be longer than ${INPUT_FIELD_MAX_CHARACTER_LIMITS.companyName} characters.`, "custom/failed-signup-inputs")
        }
    }

    get signUpUserData(): SignUpUserData {
        return {
            isNewUser: true,
            providerId: "password",
            profile: {
                email: this.email,
                firstName: this.firstName,
                lastName: this.lastName,
                displayName: this.displayName,
                campaign: this.campaign,
                userProvidedCompanyName: this.userProvidedCompanyName
            },
            status: this.status,
        }
    }
}


export async function CampaignSignUp(payload: CampaignSignUpPayload): Promise<void> {
    try {
        await doSignUp(payload)
    } catch (error: any) {
        if (error?.code === "auth/email-already-in-use") {
            console.warn(`Sign Up Exception :: Occurred for ${payload.email}`, error);
        } else {
            console.error(
                `Sign Up Exception :: Occurred for ${payload.email}. They could not sign up.`,
                error
            );
            metricsQueue.add({
                name: "SignUpException",
                value: 1,
                metricCategory: "auth",
            });
        }
        throw error
    }
}